import styled, { css, DefaultTheme, SimpleInterpolation, ThemedStyledProps } from 'styled-components';

import { VisitSettlementStatus } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

type StyledIconProps = {
   $status: VisitSettlementStatus | null;
};

const resolveFill = ({
   theme,
   $status,
}: ThemedStyledProps<StyledIconProps, DefaultTheme>): SimpleInterpolation | null => {
   switch ($status) {
      case 'SETTLED_CORRECTLY':
         return css`
            fill: ${theme.success};
         `;
      case 'SETTLED_WITHOUT_MEDICAL_SERVICES':
         return css`
            fill: ${theme.warning};
         `;
      case 'SETTLED_INCORRECTLY':
         return css`
            fill: ${theme.error};
         `;
      case 'UNSETTLED':
         return css`
            fill: ${theme.textBody};
         `;
      case null:
         return null;
      default:
         return assertUnreachable($status);
   }
};

export const StyledPrescriptionVisitSettlementIcon = styled.div<StyledIconProps>`
   display: flex;
   justify-content: center;
   height: 20px;

   > svg {
      ${resolveFill};
      width: 20px;
      height: 20px;
   }
`;

StyledPrescriptionVisitSettlementIcon.displayName = 'StyledPrescriptionVisitSettlementIcon';

export const StyledAmountWrapper = styled.div`
   margin-left: auto;
   padding-left: 8px;
   flex-shrink: 0;
`;

StyledAmountWrapper.displayName = 'StyledAmountWrapper';

export const StyledSettlementCellContainer = styled(StyledFlex).attrs({
   direction: 'column',
   gap: '4px',
})`
   width: 100%;
`;

StyledSettlementCellContainer.displayName = 'StyledSettlementCellContainer';

export const StyledSettlementRow = styled(StyledFlex).attrs({
   gap: '4px',
   alignItems: 'center',
})`
   width: 100%;
`;

StyledSettlementRow.displayName = 'StyledSettlementRow';
